var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-layout-app"},[_c('Header'),_c('app-main',{class:_vm.page.isHeaderShow ? 'my-layout-appMain' : 'my-no-header-appMain'}),(!_vm.page.noFooter)?_c('Footer',{staticClass:"my-layout-footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }